import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-coupon-slider-3',
  templateUrl: './coupon-slider-3.component.html',
  styleUrls: ['./coupon-slider-3.component.css']
})
export class CouponSlider3Component implements OnInit {
  @Input() coupon: any;
  @Input() typeCode: number;

  @Output() couponSettingsChanged = new EventEmitter<any>();

  changeCouponSettings() {
    if (this.coupon.soglia[0] > this.coupon.soglia_max) {
      this.coupon.soglia[0] = this.coupon.soglia_max;
      this.coupon.soglia[1] = this.coupon.soglia_max;
    }
    this.couponSettingsChanged.emit(this.typeCode);
  }

  constructor() { }

  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// ./src/app/views/campaign/new-campaign/step-4/coupons/coupons-sliders/coupon-slider-3/coupon-slider-3.component.ts